var map = {
  "./en.json": "852196",
  "./fr-CA.json": "502502",
  "./sv.json": "260054",
  "./hu.json": "43140",
  "./ja.json": "641522",
  "./nl.json": "229357",
  "./de.json": "599160",
  "./es-419.json": "921432",
  "./es.json": "711107",
  "./fr.json": "580063",
  "./it.json": "778474",
  "./pt.json": "860991"
};
function __rspack_async_context(req) {
  return Promise.resolve().then(function() {
if(!__webpack_require__.o(map, req)) {
  var e = new Error("Cannot find module '" + req + "'");
  e.code = 'MODULE_NOT_FOUND';
  throw e;
}

var id = map[req];
return __webpack_require__.t(id, 1 | 16);
});
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 252404;
module.exports = __rspack_async_context;
